import React from "react";
import RegistrationPage from "./pages/RegistrationPage/RegistrationPage";

const anonymousRoutes = [
   { path: "/Registration", exact: true, name: "RegistrationPage", component: RegistrationPage },
];

export default anonymousRoutes;
